<template>
  <div class="custom-input">
    <label v-if="$validate.DataValid(label)" class="input-label">{{ $t(label) }} <template v-if="isAppMode(['DEV','UAT']) && syncActive">
            <v-checkbox
              v-model="localSync"
              :label="$t('useDefaultWhatsapp')"
              color="primary"
            ></v-checkbox></template></label>
    <v-textarea
      outlined
      single-line
      :dense="dense"
      :value="fieldValue"
      :disabled="disabled"
      :readonly="isReadOnly"
      :hide-details="hideDetails"
      :placeholder="$t(placeholder)"
      :rules="[v => (required ? $validate.required(v) || $t('message.formRequired') : true)]"
      :class="inputClass"
      @input="updateValue($event)"
      :no-resize="noResize"
      :rows="rows" 
    ></v-textarea>
      <!-- :style="((isAppMode(['DEV']) && syncActive && !readonly) || (isAppMode(['DEV']) && !syncActive) || !isAppMode(['DEV'])) ? '' : 'display:none'" -->
  </div>
</template>

<script>
export default {
  name: 'FormTextarea',
  props: {
    label: {
      type: String,
      required: false,
      default: '',
    },
    syncActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    syncValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: false,
    },
    fieldValue: {
      type: String | Number,
      required: true,
      default: '',
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    dense: {
      type: Boolean,
      required: false,
      default: true,
    },
    customInputClass: {
      type: String,
      required: false,
      default: '',
    },
    dispatchUpdateOnChange: {
      type: Boolean,
      required: false,
      default: false,
    },
    noResize: {
      type: Boolean,
      required: false,
      default: false,
    },
    rows: {
      type: Number,
      required: false,
      default: 5
    }
  },
  computed: {
    isReadOnly() {
      return this.readonly || this.$store.getters.isLoading
    },
    inputClass() {
      let classObj = {
        'pointer-none': this.$store.getters.isLoading,
      }
      if (this.$validate.DataValid(this.customInputClass)) {
        const arr = this.customInputClass.split(' ')
        arr.forEach(name => {
          if (this.$validate.DataValid(name.trim())) {
            classObj[name.trim()] = true
          }
        })
      }

      return classObj
    },
    localSync: {
      get() { return this.syncValue; },
      set(val) { this.$emit('update:syncValue', val); },
    },
  },
  watch: {
    syncValue: { immediate: true, handler(v) { console.log('syncValue', v) } },
  },
  data: () => ({}),
  methods: {
    updateValue(value) {
      this.searchText = value
      this.$emit('update:fieldValue', value)
      this.$emit('input-value', value)
      if (this.dispatchUpdateOnChange === true) {
        this.$store.dispatch('setDataIsUpdated', true)
      }
    },
    // syncChange(val) {
    //   this.$emit('update:syncValue', val); // or your existing event
    // },

  },
}
</script>
